import { ChangedCourseDetails } from "~/pages/Editor/EditorCatalogEducationalPrograms/EditorPositionsAndTrainingPrograms/ProgramsManagement/types";
import { TLevel } from "~/pages/Editor/EditorCatalogEducationalPrograms/types";
import { FormStatus } from "~/shared/lib/statuses";

type UseUpdateCourseProps = {
  setCollectedData: any;
  updatedCourse: ChangedCourseDetails;
  levelId: string;
  oldCourseId: string;
};
const useUpdateCourse = ({
  setCollectedData,
  updatedCourse,
  levelId,
  oldCourseId,
}: UseUpdateCourseProps) => {
  const newCourseId = updatedCourse.course.value;
  const newCourseName = updatedCourse.course.label;
  const newCourseStatus = FormStatus[updatedCourse.status.value];
  const newCoursesCertValidityPeriod = Number(
    updatedCourse.course.certificateValidityPeriod
  );
  setCollectedData((prevState) => {
    const updatedLevel = prevState.levels.map((level: TLevel) => {
      if (level.id === levelId) {
        const updatedCourse = level.courses.map((course) => {
          if (course.id === oldCourseId) {
            return {
              ...course,
              id: newCourseId,
              name: newCourseName,
              status: newCourseStatus,
              certificateValidityPeriod: newCoursesCertValidityPeriod,
            };
          }
          return course;
        });
        return {
          ...level,
          courses: updatedCourse,
        };
      }
      return level;
    });
    return {
      ...prevState,
      levels: updatedLevel,
    };
  });
};

export default useUpdateCourse;
